export default __webpack_public_path__ + "static/media/MNFLX-UST.dc982298.svg";